import { createTheme, ThemeOptions } from "@mui/material/styles";

export const theme: ThemeOptions = createTheme({
  palette: {
    mode: "light",
    primary: {
      main: "#000000",
    },
    secondary: {
      main: "#ff7331",
    },
    error: {
      main: "#FC7C7C",
    },
    warning: {
      main: "#fdd17a",
    },
    success: {
      main: "#c0ddb9",
    },
  },
  shape: {
    borderRadius: 0,
  },
});
